<mat-form-field class="year-chooser compact no-error hover-background-primary" [class.warning]="!isCurrentFinancialYear">
  <mat-select [value]="user.financialYear" (selectionChange)="switch($event.value)" name="year-chooser-select">
    @for (year of user.financialYears; track year; let i = $index) {
      <mat-option [value]="year">
        @if (year == lastFinYear) {
          Current FY
        } @else {
          FY: {{ year | financialYear: 'long' }}
        }
      </mat-option>
    }
  </mat-select>
  <i matPrefix class="icon icon-calendar"></i>
  <i matSuffix class="fa fa-chevron-down fs-default"></i>
</mat-form-field>
